import { render, staticRenderFns } from "./ReportingUnits.vue?vue&type=template&id=7649843b&scoped=true"
import script from "./ReportingUnits.vue?vue&type=script&lang=js"
export * from "./ReportingUnits.vue?vue&type=script&lang=js"
import style0 from "./ReportingUnits.vue?vue&type=style&index=0&id=7649843b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7649843b",
  null
  
)

export default component.exports